
import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory, useParams} from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  Alert,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader"

import { getCampaignRead } from "../../helpers/backend";

import {  campaignUpdate, } from "../../store/actions";
import { getAccountFullList } from "../../helpers/backend";
import { getContactsFullList } from "../../helpers/backend";

const CampaignUpdate = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const id = useParams().id


  const getCampaignData = async () => {
    const response = await getCampaignRead(id);
    const data = response.data;
    console.log(data);
    setFormData({
      name: data.name,
      account:data.account,
      description:data.description,
      encargado: data.encargado,

    })
  };
useEffect(() => {
  getCampaignData();
  getAccountData();
  getContactsData();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[])

const [accountList, setAccountList] = useState({});
const getAccountData = async () => {
  const response = await getAccountFullList();
  const data = response.data;
  setAccountList(data);
};

const [contactsList, setContactsList] = useState({});
const getContactsData = async () => {
  const response = await getContactsFullList();
  const data = response.data;
  setContactsList(data);
};

  const [formData, setFormData] = useState({
    name: "",
    account: "",
    description:"",
    encargado: "",
  });
  
  const {
    name, 
    account,   
    description, 
    encargado,

  } = formData;
  
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  
  
  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(campaignUpdate( id, formData));
  };
  
  const redirect = () => {
    history.push("/campaign");
  };
console.log(formData);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>  | Campañas  </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem=" Campañas " />
          {props.loading ? (
            <Loader />
          ) : (
          <div className="d-flex justify-content-center">
              {props.campaignUpdated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Se ha
                  actualizado <b>{props.campaignUpdated.nombre}</b> correctamente.
                </SweetAlert>
              ) : null}

              <Card
                style={{
                  width: "60rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Campaign</h2>
                </CardTitle>
                <CardBody>
                <Form onSubmit={onSubmit}>
                  <Row className="justify-content-md-center" >
                    <Col lg={12}>
                    <Row className="mt-3">
                  <Col>
                    <Label
                      for="name"                      
                    >
                      Nombre
                    </Label>
                    <Input                      
                      id="name"
                      name="name"
                      type="name"
                      onChange={onChange}
                      value= {name}
                      autoFocus
                      required
      
                    />
                    {props.error && props.error.name ? (
                      <Alert color = 'danger' className="mt-2">{props.error.name}</Alert>
                    ):null}
                  </Col>  
                  <Col>
                    <Label
                      for="account"
                      
                    >
                      Cuenta
                    </Label>
                    <Select                                        
                      id="account"
                      name="account" 
                      placeholder='Seleccione'                        
                      options={Array.isArray(accountList)? accountList.map(item=> 
                        ({label: item.get_full_name, value: item.id})):[]}                  
                      onChange={ (item) => setFormData({
                        ...formData,
                        account: item.value,
                      })

                      }
                      defaultValue={ account }                                          
                      required 
                    />                   
                    
                    {props.error && props.error.account ? (
                    <Alert color = 'danger' className="mt-2">{props.error.account}</Alert>
                    ):null}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>  
                    <Label
                      for="description"
                      
                    >
                      Descripcion
                    </Label>
                    <Input
                     
                      id="description"
                      name="description"
                      type="text"
                      onChange={onChange}
                      value={description}

                      required 
                    />
                   
                    <FormFeedback>{props.error.description}</FormFeedback>
                    

                  </Col>
                  <Col>
                    <Label
                      for="encargado"                      
                    >  Encargado
                    </Label>  
                   <Select                                      
                      id="encargado"
                      name="encargado" 
                      placeholder='Seleccione' 
                      options={ Array.isArray(contactsList) ? 
                        contactsList.map(item=> ({label: item.get_full_name, value: item.id})) : [] }                  
                      onChange={(item) => setFormData({
                        ...formData,
                        encargado : item && item.map( item => item.value)
                      })}      
                      defaultValue= {encargado}                                         
                      required 
                    /> 
                    

                    {props.error && props.error.encargado ? (
                    <Alert color = 'danger' className="mt-2">{props.error.encargado}</Alert>
                    ):null}

                  </Col>
                </Row>

                    <Row className="justify-content-md-center mt-3 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-secondary me-4" to="/campaign">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar
                        </Button>
                      </Col>
                    </Row>
                    </Col>
                  </Row>
                  </Form>
                </CardBody>
              </Card>

            
          </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { error, loading, campaignUpdated } = state.Campaign;
  return { error, loading, campaignUpdated };
};

export default withRouter(connect(mapStateToProps)(CampaignUpdate));

